import { useEffect, useRef } from "react";
import { formatDecimal } from "../utils/decimalFormat";

const RevenueChart = ({ data }) => {
  const containerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!window.ApexCharts) return;

    const labelColor =
      getComputedStyle(document.documentElement)
        .getPropertyValue("--kt-gray-500")
        .trim() || "#6c757d";
    const borderColor =
      getComputedStyle(document.documentElement)
        .getPropertyValue("--kt-gray-200")
        .trim() || "#e5e5e5";

    const options = {
      series: [
        { name: "Wallet Recharge", data: data.map((d) => formatDecimal(d.walletRecharge)) },
        { name: "Revenue", data: data.map((d) => formatDecimal(d.revenue)) },
        { name: "Driver Share", data: data.map((d) => formatDecimal(d.driverShare)) },
        { name: "Company Share", data: data.map((d) => formatDecimal(d.companyShare)) },
      ],
      chart: {
        type: "bar",
        height: 450,
        fontFamily: "inherit",
        toolbar: { show: false },
        zoom: { enabled: false },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          endingShape: "rounded",
        },
      },
      xaxis: {
        categories: data.map((d) => `${d.month} ${d.year}`),
        labels: { style: { colors: labelColor, fontSize: "12px" } },
      },
      yaxis: {
        labels: {
          style: { colors: labelColor, fontSize: "12px" },
          formatter: (val) => `${val}`,
        },
        title: { text: "Amount (KWD)" },
      },
      tooltip: {
        y: { formatter: (val) => `${val} KWD` },
        style: { fontSize: "12px" },
      },
      colors: ["#0d6efd", "#198754", "#ffc107", "#dc3545"],
      legend: { position: "bottom", horizontalAlign: "center" },
      dataLabels: { enabled: false },
      grid: { borderColor: borderColor, strokeDashArray: 4 },
      states: {
        normal: { filter: { type: "none", value: 0 } },
        hover: { filter: { type: "none", value: 0 }, cursor: "pointer" },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: { type: "none", value: 0 },
        },
      },
      responsive: [
        {
          breakpoint: 768,
          options: {
            plotOptions: {
              bar: {
                columnWidth: "70%",
              },
            },
            xaxis: {
              labels: {
                rotate: -45,
                style: { fontSize: "10px" },
              },
            },
            yaxis: {
              labels: { style: { fontSize: "10px" } },
            },
            chart: {
              height: 350,
            },
            legend: {
              position: "bottom",
              fontSize: "10px",
            },
          },
        },
        {
          breakpoint: 480,
          options: {
            plotOptions: {
              bar: { columnWidth: "90%" },
            },
            xaxis: { labels: { rotate: -60, style: { fontSize: "9px" } } },
            yaxis: { labels: { style: { fontSize: "9px" } } },
            chart: { height: 300 },
            legend: { fontSize: "9px" },
          },
        },
      ],
    };

    const chart = new window.ApexCharts(containerRef.current, options);
    chart.render();
    chartRef.current = chart;

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [data]);

  return <div ref={containerRef} style={{ width: "100%", minHeight: 450 }} />;
};

export default RevenueChart;
